import { Divider, List, ListItem, Typography } from "@mui/material";
import { Grid } from "@mui/system";
import { CodeBlock } from "../../code";

export const IttechPowershellRepeat = () => {
  return (
    <>
      <Typography variant="h4">1. If / Else VS Switch</Typography>

      <Grid
        container
        sx={{
          "& .MuiListItem-root": {
            fontSize: "2em",
          },
          "ul li:first-child": { fontWeight: "bold" },
        }}
      >
        <Grid size={4}>
          <List>
            <ListItem>2: Herhaling, herhaling herhaling! 🔁</ListItem>
            <Divider sx={{ my: 2 }} />
            <ListItem>📖 Reader: pagina 45</ListItem>
            <ListItem>☞ Variabelen</ListItem>
            <ListItem>☞ Simpele "operators" (+ - * /)</ListItem>
            <ListItem>☞ If / Else</ListItem>
            <ListItem>☞ If / Elseif / Else</ListItem>
            <ListItem>☞ Foreach / For</ListItem>
          </List>
        </Grid>
        <Grid size={4}>
          <List>
            <ListItem>🏃 3: Progressbar 🔋</ListItem>
            <Divider sx={{ my: 2 }} />
            <ListItem>☞ Schrijf een script met de volgende output;</ListItem>
            <ListItem>
              <CodeBlock>
                [#] 10 % <br />
                ... <br /> [##########] 100% <br />
                <br />
                Download complete! ✅
              </CodeBlock>
            </ListItem>
          </List>
        </Grid>
        <Grid size={4}>
          <List>
            <ListItem>🚀 4: De Naam Challenge</ListItem>
            <Divider sx={{ my: 2 }} />
            <ListItem>☞ Maak een loop; 1 t/m 20; Schrijf het getal</ListItem>
            <ListItem>☞ Getal deelbaar door 3? Schrijf voornaam</ListItem>
            <ListItem>☞ Getal deelbaar door 5? Schrijf achternaam</ListItem>
            <ListItem>
              ☞ Getal deelbaar door zowel 3 als 5? Schrijf Voornaam + Achternaam
            </ListItem>
          </List>
        </Grid>
      </Grid>
    </>
  );
};
